import React, { useEffect } from 'react'

const LocationView = ({ location }: any) => {

    useEffect(() => {
         if (!location?.coordinates) return;
        const map = new google.maps.Map(
            document.getElementById("previewMap") as HTMLElement,
            {
                center: {
                    lng: location?.coordinates?.[0],
                    lat: location?.coordinates?.[1],
                },
                zoom: 15,
            }
        );
        new google.maps.Marker({
            position: {
                lng: location?.coordinates?.[0],
                lat: location?.coordinates?.[1],
            },
            map: map,
            title: "Location",
        });
    }, [location]);


    return (
        <div>
            <div
                id="previewMap"
                style={{
                    width: "100%",
                    height: "400px",
                    margin: "auto",
                    borderRadius: "10px",
                    border: "1px solid #ccc",
                    marginTop: "10px",
                }}
            />
        </div>
    )
}

export default LocationView